import styled from "styled-components";
import { theme } from "../../theme";

export const StyledInput = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 16px;

  label {
    font-size: 14px;
    margin-bottom: 5px;
    font-weight: 500;
  }
  small {
    font-size: 12px;
    font-weight: 500;
  }
  small.error {
    color: ${theme.textColor.primaryRed};
  }
  small.helper-text {
    color: ${theme.textColor.quaternaryGray};
    margin-top: 5px;
  }
`;

export const StyledInputContainer = styled.div<{ error: string }>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  input {
    outline: none;
    border: none;
    background-color: ${theme.backgroundColor.primaryWhite};
    color: ${theme.textColor.primaryBlack};
    padding: 10px;
    border: 2px solid
      ${({ error }) =>
        error
          ? theme.backgroundColor.primaryRed
          : theme.backgroundColor.primaryGray};
    font-size: 16px;
    font-weight: 500;
    width: 100%;
    &:disabled {
      background-color: ${theme.backgroundColor.primaryGray};
      border-left: 1px solid ${theme.backgroundColor.secondaryGray};
      cursor: not-allowed;
    }
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }

  div.adornment {
    padding: 10px;
    background-color: ${theme.backgroundColor.primaryGray};
    border: 2px solid ${theme.backgroundColor.primaryGray};
    color: ${theme.textColor.secondaryBlack};
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
`;
